// extracted by mini-css-extract-plugin
module.exports = {"item":"P_df","item__image":"P_dg","item__title":"P_dn","item__counter":"P_dp","item__active":"P_dq"};